import React from 'react'
import { Card } from 'antd'
import './index.less'

class SectionHeader extends React.Component {
  constructor(props, context) {
    super(props, context)
  }

  render() {
    const { title } = this.props

    return (
      <Card className='section-content' title={title} >
        {this.props.children}
      </Card>
    )
  }
}

export default SectionHeader



// WEBPACK FOOTER //
// src/components/SectionContent/index.jsx